import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomBreadcrumbComponent } from './custom/breadcrumb/breadcrumb.component';
import { CustomComponent } from './custom/custom.component';
import { HorizontalHeaderComponent } from './custom/horizontal/header.component';
import { HorizontalNavigationComponent } from './custom/horizontal/navigation.component';
import { VerticalHeaderComponent } from './custom/vertical/header.component';
import { NavigationItemComponent } from './custom/vertical/navigation-item.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NavService } from './nav.service';
import { CoreModule } from '../core/core.module';
import { CustomizerComponent } from './custom/customizer/customizer.component';
import { BrandingComponent } from './custom/branding/branding.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  declarations: [
    CustomComponent,
    CustomBreadcrumbComponent,
    HorizontalHeaderComponent,
    HorizontalNavigationComponent,
    VerticalHeaderComponent,
    NavigationItemComponent,
    BrandingComponent
  ],
  imports: [
    RouterModule,
    CoreModule,
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    NgScrollbarModule,
    CustomizerComponent,
  ],
  exports: [BrandingComponent],
  providers: [NavService],
})
export class LayoutModule {}
